// extracted by mini-css-extract-plugin
export var divider = "_rz-0";
export var systemMessage = "_rz-1";